module.exports = __webpack_public_path__ + "static/media/expressjs.de42f444.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/expressjs.png
// module id = 103
// module chunks = 0